import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { POST_AMENITY_REQUEST, PUT_AMENITY_REQUEST } from "../../../../../../Utils/Constant";

const AddAmenity = ({
  selectedAmenity,
  setListUpdated,
  setSelectedAmenity,
}) => {
  const dispatch = useDispatch();
  const closeBtnRef = useRef(null);

  const [amenityName, setAmenityName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    if (selectedAmenity) {
      setAmenityName(selectedAmenity.amenity_name || "");
    } else {
      setAmenityName("");
    }
  }, [selectedAmenity]);

  const validate = () => {
    if (!amenityName.trim()) {
      setError("Amenity name is required.");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const hotel_id=localStorage.getItem('hotel_id');
    const payload = {
      amenity_name: amenityName,
      hotel_id:hotel_id
      // onSuccess: () => {
      //   toast.success(
      //     selectedAmenity
      //       ? "Amenity updated successfully!"
      //       : "Amenity created successfully!"
      //   );
      //   setListUpdated((prev) => !prev);
      //   setSelectedAmenity(null);
      //   closeBtnRef.current?.click();
      // },
      // onFailure: (msg) => {
      //   toast.error(msg || "Something went wrong!");
      // },
    };

    dispatch({
      type: selectedAmenity?.id ? PUT_AMENITY_REQUEST : POST_AMENITY_REQUEST,
      payload: selectedAmenity?.id
        ? { ...payload, id: selectedAmenity.id }
        : payload,
    });
       setSelectedAmenity(null);
        closeBtnRef.current?.click();
  };

  const handleClear = () => {
    setAmenityName("");
    setError("");
    setSelectedAmenity(null);
  };

  return (
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="add-amenity">
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {selectedAmenity ? "Edit Amenity" : "Add Amenity"}
        </h5>
        <button
          ref={closeBtnRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={handleClear}
        ></button>
      </div>
      <div className="offcanvas-body">
        <form>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Amenity Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${error ? "is-invalid" : ""}`}
              placeholder="Enter Amenity Name"
              value={amenityName}
              onChange={(e) => {
                setAmenityName(e.target.value);
                setError("");
              }}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
        </form>

        <div className="d-flex">
          <button
            type="button"
            className="btn w-100 me-2 btn-secondary"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn w-100 btn-primary"
            onClick={handleSubmit}
          >
            {selectedAmenity ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAmenity;
